export interface WokDataGridConfiguration {
    update: boolean;
    locale: any;
    columns: WokDataGridColumn[];
}

export interface WokDataGridColumn {
    index: number;
    label: string;
    align: string;
    display: string;
    headerSpan: number;
    dataName: string | null;
    dataIndex: string | number | null;
    dataType: string;
    dataPrecision: number;
    dataFormat: ((item: any, index: number, cellValue: any) => string) | null;
    dataAggregate: ((items: any[], index: number) => string) | null;
}

export function isNumericDataType(v: string) {
    return /(integer|number|currency)/.test(v || 'text');
}
